//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    appList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // 流程模版信息
      processModelInfo: {
        // 业务模块
        module: '',
        // 业务类型
        biz_type: '',
        process_key: '',
        edit_process_name: '',
        edit_process_desc: '',
        edit_json: '{}',
        app_id: '',
        preset: false,
        // dcr 业务类型区分选择 默认使用 业务类型(biz_type); 类型变量 custom_variable
        dcrTypeOption: 'biz_type',
      },
    };
  },
  watch: {
    'processModelInfo.dcrTypeOption'(val) {
      if (val === 'custom_variable') {
        this.processModelInfo.biz_type = '';
      }
    },
    'processModelInfo.module'(val) {
      if (val !== 'DCR') {
        this.processModelInfo.dcrTypeOption = 'biz_type';
      }
    },
  },
  computed: {
    ...mapGetters({
      businessTypeList: 'workflow/getBusinessTypeList',
      businessModuleList: 'workflow/getBusinessModuleList',
    }),
  },
  methods: {
    submit() {
      this.$refs.processModelForm.validate(async (valid) => {
        if (!valid) {
          return;
        }
        try {
          const params = {
            ...this.processModelInfo,
            biz_type:
              this.processModelInfo.dcrTypeOption === 'custom_variable'
                ? this.processModelInfo.dcrTypeOption
                : this.processModelInfo.biz_type,
            dcrTypeOption: undefined,
          };
          const { id } = await this.$request({
            url: this.$api.createEditProcess,
            data: params,
          });
          if (id) {
            this.$message.success('创建成功');
            setTimeout(() => {
              this.$router.push({
                name: 'workflow-detail',
                query: {
                  id,
                },
              });
            }, 500);
          }
        } catch (err) {
          console.log(err);
        }
      });
    },
    close() {
      this.processModelInfo.app_id = '';
      this.processModelInfo.edit_process_name = '';
      this.processModelInfo.process_key = '';
      this.processModelInfo.edit_process_desc = '';
      this.processModelInfo.module = '';
      this.processModelInfo.biz_type = '';
      this.processModelInfo.preset = false;
      (this.processModelInfo.dcrTypeOption = 'biz_type'), this.$emit('close');
    },
  },
};
